import Notify from '@xt/Notify';
import cs from './index.module.scss';

export const TradeFooter = () => {
  return (
    <div className={cs.container}>
      <Notify />
    </div>
  );
};